<template>
  <article class="choose-store">
    <ul class="choose-store-ul">
      <li
        v-for="item in storesConfig"
        :key="item.store_id"
        @click="selectStore(item.store_id)">
        {{item.store_name}}
      </li>
    </ul>
  </article>
</template>

<script>
import cache from '@/common/cache'
import Cookies from 'js-cookie'
export default {
  mounted() {
    this.showToast('请选择要登录的门店')
  },
  methods: {
    selectStore (id) {
      this.$rest.auth.chooseStore(id)().then((res) => {
        if (res.status === 403) {
          this.showToast(res.body.message)
          return
        }
        if (res.code !== 0) {
          this.showToast(res.message)
          return
        }
        cache.setLocalStorageData('last_store_id', id.toString())
        // Cookies.set('last_store_id', id.toString())
        cache.setSessionData('access_token', res.data['access-token'])
        let href = window.location.href
        href = href.split('choose_store?next=')
        href = href[href.length - 1]

        cache.clearSessionData('hasLogin')
        window.location.href = decodeURIComponent(href)
      })
    }
  }
}
</script>

<style lang="less">
@w2: 75rem;
.choose-store {
  .weui_cell_hd {
    display: none;
  }
  .choose-store-ul {
    background-color: #fff;
    li {
      padding-left: 30/@w2;
      line-height: 88/@w2;
      box-shadow: 0px 1px 0px 0px #e6e6e6;
      font-size: 28/@w2;
    }
  }
}

</style>
